import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderBookmarks: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFolderBookmarks"><Path fillRule="evenodd" clipRule="evenodd" d="M2 3H10.5352L12.5352 6H22V20H10V11H2V3Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M1 13H8V21.7662L4.5 19.6662L1 21.7662V13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderBookmarks;
